import { makeStyles } from '@material-ui/styles';
import {
    useMessageContext,
    useChannelActionContext,
    useChannelStateContext,
} from 'stream-chat-react';
import { Text } from '@bizzabo/design-system';
import { sendMessageRequest } from '../../../utils/sendMessageUtils';
import useTypeTracking from '../../../../../analytics';

const MessageRetry: React.FC = () => {
    const { trackSystemEvent } = useTypeTracking();
    const { message } = useMessageContext();
    const { updateMessage } = useChannelActionContext();
    const { channel } = useChannelStateContext();
    const classes = useStyles();

    const sendSnowplowEvent = (actionName: string, messageId: string) => {
        const payload = {
            action: actionName,
            message_type: 'text',
            channel_type: channel.type,
            messageId: messageId,
        };

        trackSystemEvent({
            description: payload,
        });
    };

    const handleRetryClick = async () => {
        updateMessage({ ...message, errorStatusCode: undefined, status: 'sending' });
        sendSnowplowEvent('MESSAGE_RESEND_ATTEMPT', message.id);
        const messageSentSuccessfully = await sendMessageRequest(channel, message, updateMessage);
        if (messageSentSuccessfully) {
            sendSnowplowEvent('MESSAGE_RESEND_SUCCESS', message.id);
        }
    };

    return (
        <>
            <Text className={classes.failedText} variant="t81">
                Failed to deliver
            </Text>
            <Text variant="t81" className={classes.tryAgain} onClick={handleRetryClick}>
                Try again
            </Text>
        </>
    );
};

const useStyles = makeStyles(
    theme => ({
        failedText: {
            paddingLeft: 6,
            marginLeft: 4,
            marginTop: 3,
            marginRight: 4,
            position: 'relative',
            color: theme.palette.greys[500],
            '&::before': {
                content: "''",
                width: 3,
                height: 3,
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                background: theme.palette.primary[500],
                borderRadius: '50%',
            },
        },
        tryAgain: {
            marginTop: 3,
            color: theme.palette.accent[600],
            cursor: 'pointer',
        },
    }),
    { classNamePrefix: 'chat-message-retry' }
);

export default MessageRetry;
